<template>
  <div class="page-root">
    <div class="confirm-card">
      <div class="confirm-icon-wrap">
        <v-icon size="40" color="#0052A0">mdi-email-check-outline</v-icon>
        <div class="confirm-icon-ring"></div>
      </div>

      <h1 class="confirm-title">Cadastro enviado para análise!</h1>

      <p class="confirm-text">
        Recebemos os dados e documentos do seu credor com sucesso. Nossa equipe vai
        analisar tudo com cuidado — assim que o cadastro for aprovado (ou se
        precisarmos de algum ajuste), você será avisado por e-mail
        <strong v-if="email">em <span class="confirm-email">{{ email }}</span></strong
        ><span v-else>no endereço informado no cadastro</span>.
      </p>

      <p class="confirm-subtext">
        Esse processo costuma ser rápido. Você já pode voltar para o início — quando
        a análise for concluída, o status do seu credor vai aparecer atualizado por lá.
      </p>

      <v-btn
        color="#0052A0"
        rounded
        elevation="0"
        class="px-6 confirm-cta"
        :to="{ name: 'Home' }"
      >
        <v-icon left color="#FFD400" small>mdi-home-outline</v-icon>
        <span style="color:#FFD400;font-weight:700;font-size:13px">Voltar para o início</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.page-root {
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-card {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.05);
  padding: 48px 44px;
  box-sizing: border-box;
  text-align: center;
  animation: confirm-card-in 0.5s ease both;
}

.confirm-icon-wrap {
  position: relative;
  width: 76px;
  height: 76px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8f0fe;
  border-radius: 50%;
  animation: confirm-icon-in 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both;
}

.confirm-icon-ring {
  position: absolute;
  inset: -6px;
  border: 2px solid #0052a0;
  border-radius: 50%;
  opacity: 0;
  animation: confirm-ring-pulse 1.6s ease-out 0.5s;
}

.confirm-title {
  font-family: 'Inter', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 14px;
}

.confirm-text {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  color: #475569;
  line-height: 1.6;
  margin-bottom: 12px;
}

.confirm-email {
  color: #0052a0;
  font-weight: 700;
}

.confirm-subtext {
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  color: #94a3b8;
  line-height: 1.5;
  margin-bottom: 28px;
}

.confirm-cta {
  animation: confirm-card-in 0.5s ease 0.25s both;
}

@keyframes confirm-card-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes confirm-icon-in {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes confirm-ring-pulse {
  from {
    opacity: 0.5;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(1.35);
  }
}

@media (prefers-reduced-motion: reduce) {
  .confirm-card,
  .confirm-icon-wrap,
  .confirm-cta,
  .confirm-icon-ring {
    animation: none;
  }
}

@media (max-width: 768px) {
  .page-root {
    padding: 16px;
  }
  .confirm-card {
    padding: 32px 24px;
  }
}
</style>
